import styled from 'styled-components'
import { tokens } from '../../../assets/tokens'

export const Form = styled.form`
  display: flex;
  flex-direction: column;
  gap: 16px;
`

export const Label = styled.label`
  display: block;
  margin-bottom: 8px;
  font-size: 14px;
  font-weight: 500;
  color: ${tokens.color.text.label};
`

export const LinkButton = styled.button`
  align-self: flex-end;
  padding: 0;
  border: none;
  background: none;
  cursor: pointer;
  font-family: ${tokens.typography.fontFamily.primary};
  font-size: 14px;
  font-weight: 500;
  color: ${props => props.theme.primary || tokens.color.brand.primary};
`
